export default "__VITE_ASSET__DthGFOSO__"